module fdm.common {
    function removeAuthHeaderForTemplatesInterceptor($rootScope: ng.IRootScopeService, $q: ng.IQService, $timeout: ng.ITimeoutService) {
        return {

            request: (config: ng.IRequestConfig) => {
                if (config && config.url.indexOf("/api/") != 0) {
                    var headers: any = config.headers;
                    headers.Authorization = null;
                }

                return config;
            }
        };
    }

    angular.module('fdm.common')
        .service('removeAuthHeaderForTemplatesInterceptor', removeAuthHeaderForTemplatesInterceptor);
}